import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Card, CardContent, Checkbox, CircularProgress, FormControlLabel, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import api from 'services/api';
import { baixarRelatorio } from 'services/relatorios';

const inicial = () => ({ datainicial: '', datafinal: '', codusuario: 0, descricao: '', operacoes: [], agrupar: true, historicoos: false });
export default function LogsRelatorio() {
  const { pathname } = useLocation();
  const modulo = pathname.split('/')[1];
  const endpoint = `/relatorios/${modulo}/logs`;
  const [filtro, setFiltro] = useState(inicial);
  const [opcoes, setOpcoes] = useState({ usuarios: [], operacoes: [] });
  const [carregando, setCarregando] = useState(true);
  const [imprimindo, setImprimindo] = useState(false);
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [tentativa, setTentativa] = useState(0);
  const trava = useRef(false);
  useEffect(() => {
    let ativo = true;
    setCarregando(true); setErro(''); setMensagem(''); setFiltro(inicial());
    api.get(`${endpoint}/filtros`).then(({ data }) => {
      if (ativo) setOpcoes(data);
    }).catch(e => {
      if (ativo) setErro(e.response?.data?.message || 'Não foi possível carregar os filtros.');
    }).finally(() => { if (ativo) setCarregando(false); });
    return () => { ativo = false; };
  }, [endpoint, tentativa]);
  const alterar = (campo, valor) => { setFiltro(f => ({ ...f, [campo]: valor })); setMensagem(''); };
  async function imprimir(e) {
    e.preventDefault();
    if (trava.current) return;
    setErro(''); setMensagem('');
    if (!filtro.datainicial || !filtro.datafinal || filtro.datainicial > filtro.datafinal) {
      setErro('Informe um período válido.'); return;
    }
    if (!filtro.operacoes.length && !filtro.historicoos) {
      setErro('Marque pelo menos uma operação ou a opção de histórico de OS.'); return;
    }
    trava.current = true; setImprimindo(true);
    try {
      await baixarRelatorio(`${endpoint}/imprimir`, filtro, 'logs.pdf');
      setMensagem('Relatório gerado. Download iniciado.');
    } catch (error) { setErro(error.message); }
    finally { trava.current = false; setImprimindo(false); }
  }
  return <div style={{ padding: 24 }}>
    <Typography variant="h5" gutterBottom>Relatório de Logs</Typography>
    <Card><CardContent>
      <form onSubmit={imprimir}>
        <fieldset disabled={carregando || imprimindo} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}><TextField fullWidth required type="date" label="Data inicial" InputLabelProps={{ shrink: true }} value={filtro.datainicial} onChange={e => alterar('datainicial', e.target.value)} /></Grid>
            <Grid item xs={12} sm={6} md={3}><TextField fullWidth required type="date" label="Data final" InputLabelProps={{ shrink: true }} value={filtro.datafinal} onChange={e => alterar('datafinal', e.target.value)} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth select label="Usuário" value={filtro.codusuario} onChange={e => alterar('codusuario', Number(e.target.value))}>
              <MenuItem value={0}>Todos</MenuItem>{opcoes.usuarios.map(u => <MenuItem key={u.codigo} value={Number(u.codigo)}>{u.nome} [{u.codigo}]</MenuItem>)}
            </TextField></Grid>
            <Grid item xs={12}><TextField fullWidth label="Descrição contém" value={filtro.descricao} inputProps={{ maxLength: 250 }} onChange={e => alterar('descricao', e.target.value)} /></Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1">Operações</Typography>
              <Button size="small" onClick={() => alterar('operacoes', opcoes.operacoes.map(o => o.codigo))}>Marcar todas</Button>
              <Button size="small" onClick={() => alterar('operacoes', [])}>Desmarcar todas</Button>
              <div style={{ maxHeight: 330, overflowY: 'auto', border: '1px solid #ddd', padding: 8 }}>
                {opcoes.operacoes.map(o => <div key={o.codigo}><FormControlLabel label={`${o.descricao} [${o.codigo}]`} control={<Checkbox color="primary" checked={filtro.operacoes.includes(o.codigo)} onChange={e => alterar('operacoes', e.target.checked ? [...filtro.operacoes, o.codigo] : filtro.operacoes.filter(c => c !== o.codigo))} />} /></div>)}
              </div>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel label="Agrupar por operação" control={<Checkbox color="primary" checked={filtro.agrupar} onChange={e => alterar('agrupar', e.target.checked)} />} />
              <FormControlLabel label="Exibir histórico de OS" control={<Checkbox color="primary" checked={filtro.historicoos} onChange={e => alterar('historicoos', e.target.checked)} />} />
            </Grid>
          </Grid>
        </fieldset>
        <div style={{ marginTop: 16 }}>
          <Button type="submit" variant="contained" color="primary" disabled={carregando || imprimindo || !opcoes.operacoes.length} startIcon={imprimindo ? <CircularProgress size={18} color="inherit" /> : <PrintIcon />}>{imprimindo ? 'Gerando relatório...' : 'Imprimir'}</Button>
          <Button disabled={carregando || imprimindo} onClick={() => { setFiltro(inicial()); setErro(''); setMensagem(''); }}>Limpar filtros</Button>
          {carregando && <CircularProgress size={20} />}
        </div>
      </form>
      {erro && <div role="alert" style={{ marginTop: 16 }}><Typography color="error">{erro}</Typography>{!opcoes.operacoes.length && !carregando && <Button onClick={() => setTentativa(t => t + 1)}>Tentar carregar novamente</Button>}</div>}
      {mensagem && <Typography role="status" style={{ marginTop: 16 }}>{mensagem}</Typography>}
    </CardContent></Card>
  </div>;
}
